module.exports = __webpack_public_path__ + "static/SquareSerif-Book-webfont-cd4e2b2ed2866ae781c3e69353ee8bd6.woff";